export default __webpack_public_path__ + "static/media/ripple.ac127f7c.jpg";